module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "collapse-btn"
  }, [(!_vm.hideText) ? _c('span', [_vm._v("Collapse")]) : _vm._e(), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 7,
      "height": 11
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18c32a3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/attributePanel/CollapseButton.vue
// module id = 1819
// module chunks = 0